module.exports = require("./uz-Latn-UZ");